module.exports = __webpack_public_path__ + "media/Loops 90 Pad.3335d039.wav";